import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCaseLogs,fetchShipmentHistory,clearLogs } from "../../store/features/caseLogsSlice";



const CaseInformation = ({ threadId }) => {
  const dispatch = useDispatch();
  // Access Redux states for shipments and case logs
  const { logs, shipmentHistory, status: caseLogStatus, error: caseLogError } = useSelector((state) => state.caseLogs);
  const { shipments, status: shipmentStatus } = useSelector((state) => state.shipments);
  const shipment = shipments.find((shipment) => shipment.thread_id === threadId);
  const { thread_id, case_number, documents, emailBodies} = shipment;
  const emailLogs = emailBodies
  // Get shipment details and AI summary
  const caseLog = logs[case_number]
  const casehistory = shipmentHistory?.[case_number] || []; 
  const aiSummary = caseLog?.summary || "No summary available.";
  

  useEffect(() => {
    dispatch(clearLogs()); // Clear existing logs
    }, [dispatch, case_number]);

  // Fetch data if not already loaded
  useEffect(() => {
    const fetchData = async () => {
      if (!caseLog || !casehistory) {
        await dispatch(fetchCaseLogs(case_number));
        await dispatch(fetchShipmentHistory(case_number));
      }
    };
  
    fetchData(); // Call the async function inside useEffect
  }, [dispatch, case_number,caseLog, threadId]);

  // Unified loading state
  if (caseLogStatus === "loading" || shipmentStatus === "loading") {
    return <div>Fetching Latest information please hold on</div>;
  }

  // Unified error handling
  if (caseLogStatus === "failed") {
    return <div>{caseLogError || "Failed to load case information."}</div>;
  }


  return (
    <div>
      {/* AI Summary Section */}
      <div className="mb-6 border border-bg-Gray rounded-lg p-4 bg-white shadow-sm">
        {/* AI Badge */}
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#00405E] to-[#0085C4] text-white text-sm font-medium px-3 py-1 rounded-full shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
        </svg>

          AI Generated
        </div>

        {/* Summary */}
        <div className="ml-2">
          <h3 className="font-bold mt-3">Summary:</h3>
          <p className="text-font-LIGHT">{aiSummary}</p>
        </div>
    
      </div>

    {/* Case Log Section */}
    <div className="mb-6 border rounded-lg p-4 bg-white shadow-sm">
      <h3 className="font-bold text-md ml-2 mb-4">Shipment History</h3>
      <hr className="my-4 border-bg-Gray" />
      {casehistory
      .slice() // Create a shallow copy to avoid mutating the original array
      .sort((a, b) => {
        // Parse dates for comparison
        const dateA = new Date(`${a.created_at}`);
        const dateB = new Date(`${b.created_at}`);
        return dateB - dateA; // Sort in descending order (latest first)
      })
      .map((log, index) => (
        <div className="ml-2" key={index}>
          {/* Date and Time */}
          <p className="text-font-LIGHT mb-1">
            {log.event_date || "N/A"}
          </p>

          {/* Description */}
          <ul className="list-disc list-inside text-font-LIGHT">
            {/* Short Description */}
            {log.description && <li>{log.description}</li>}
          </ul>

          {/* Horizontal Divider */}
          {index < emailLogs.length - 1 && (
            <hr className="my-4 border-bg-Gray" />
          )}
        </div>
      ))}
        </div>
      </div>

  );
};

export default CaseInformation;


